import DirectBinary from '@adobe/aem-upload';

async function callAEMUploadSDK(file, imsToken) {
  // URL to the folder in AEM where assets will be uploaded. Folder
  // must already exist.
  console.log('aem upload through sdk', file);
  // const targetUrl = 'http://localhost:4502/content/dam/nike';
  const targetUrl =
    'https://author-p24737-e96352.adobeaemcloud.com/content/dam/dentsusymphonyaemcloud';
  const uploadFiles = [
    {
      fileName: file.name, // name of the file as it will appear in AEM
      fileSize: file.size, // total size, in bytes, of the file
      blob: file, // Full path to the local file
      filePath: '/new/path/string',
    },
  ];
  console.log('upload files', uploadFiles);
  const upload = new DirectBinary.DirectBinaryUpload();
  const options = new DirectBinary.DirectBinaryUploadOptions()
    .withUrl(targetUrl)
    .withUploadFiles(uploadFiles)
    .withHeaders({
      'content-type': file.type,
      authorization: `Bearer ${imsToken}`,
    });

  // this call will upload the files. The method returns a Promise, which will be resolved
  // when all files have uploaded.
  upload
    .uploadFiles(options)
    .then(result => {
      console.log('result', result);
    })
    .catch(err => {
      console.log('error', err);
    });
}
export default callAEMUploadSDK;
